const ArrowRightIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        width="24px"
        viewBox="0 -960 960 960"
        fill='currentColor'
    >
        <path d="M400-280v-400l200 200-200 200Z" />
    </svg>
);

export default ArrowRightIcon;
